import { create } from "zustand";
export type InstallPrompt = Event & { prompt: () => Promise<unknown> };
export const useInstallState = create<{ pending: InstallPrompt | null; installed: boolean }>(
  () => ({ pending: null, installed: false }),
);
export function captureInstallPrompt(): () => void {
  const installed =
    window.matchMedia?.("(display-mode: standalone)").matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  useInstallState.setState({ installed });
  const before = (event: Event) => {
    event.preventDefault();
    useInstallState.setState({ pending: event as InstallPrompt });
  };
  const complete = () => useInstallState.setState({ installed: true, pending: null });
  window.addEventListener("beforeinstallprompt", before);
  window.addEventListener("appinstalled", complete);
  return () => {
    window.removeEventListener("beforeinstallprompt", before);
    window.removeEventListener("appinstalled", complete);
  };
}
